import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectLoanRoleAssignmentCriteriaSchema = createSelector(
  getSystem,
  ({ loanRoleAssignmentCriteriaSchema }) => loanRoleAssignmentCriteriaSchema,
);
